import React, { type FunctionComponent } from 'react'
import { Typography } from '@mui/material'
import { Pill as PillStyled, PillText, PillNumber } from './pill.styles'

type PillProps = {
	label: string,
	count?: number,
	selected?: boolean,
	onClick?: ( label: string ) => void,
}

export const Pill: FunctionComponent<PillProps> = ( {
	count,
	label,
	selected = false,
	onClick,
} ) => {
	return (
		<PillStyled
			variant={'outlined'}
			selected={selected}
			onClick={() => {
				onClick?.( label )
			}}
			aria-label={`${label}${selected ? ' (selected)' : ''}`}
		>
			<PillText variant={'body1'}>
				{label}
			</PillText>
			{ count !== undefined && (
				<PillNumber selected={selected}>
					<Typography variant={'overline'}>{count}</Typography>
				</PillNumber>
			) }
		</PillStyled>
	)
}
